import type { ReactNode } from 'react'

type DashboardChartHostProps = {
	children: ReactNode
	className?: string
}

/** Clips ApexCharts SVG/canvas so charts cannot bleed into adjacent grid columns. */
export function DashboardChartHost({ children, className = '' }: DashboardChartHostProps) {
	return (
		<div className={`dashboard-chart-host min-w-0 w-full max-w-full overflow-hidden ${className}`.trim()}>
			{children}
		</div>
	)
}
